export default function EllipsisCardIcon(props) {
  return (
    <svg
      width={props.width || "3"}
      height={props.height || "14"}
      viewBox="0 0 3 14"
      fill={props.fill || "#FFFFFF"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill={props.fill || "#ffffff"} d="M1.4 2.8C2.17292 2.8 2.8 2.17292 2.8 1.4C2.8 0.627083 2.17292 0 1.4 0C0.627083 0 0 0.627083 0 1.4C0 2.17292 0.627083 2.8 1.4 2.8ZM1.4 11.2C0.627083 11.2 0 11.8271 0 12.6C0 13.3729 0.627083 14 1.4 14C2.17292 14 2.8 13.3729 2.8 12.6C2.8 11.8271 2.17292 11.2 1.4 11.2ZM1.4 5.6C0.627083 5.6 0 6.22708 0 7C0 7.77292 0.627083 8.4 1.4 8.4C2.17292 8.4 2.8 7.77292 2.8 7C2.8 6.22708 2.17292 5.6 1.4 5.6Z" />
    </svg>
  )
}
